import React from 'react';
import { HashRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import MenuOverview from './components/MenuOverview';
import RegistrationForm from './components/RegistrationForm';
import NextWeekMenu from './components/NextWeekMenu';
import { MenuProvider } from './context/MenuContext';
import { AuthProvider } from './context/AuthContext';
import { ServiceTimesProvider } from './context/ServiceTimesContext'; // ✅ NEUE IMPORT

// Admin Components
import LoginForm from './components/admin/LoginForm';
import AdminLayout from './components/admin/AdminLayout';
import Dashboard from './components/admin/Dashboard';
import CurrentMenus from './components/admin/CurrentMenus';
import NextWeekMenus from './components/admin/NextWeekMenus';
import MenuTemplates from './components/admin/MenuTemplates';
import Registrations from './components/admin/Registrations';
import EmailNewsletter from './components/admin/EmailNewsletter';
import DayConfiguration from './components/admin/DayConfiguration';
import HolidayConfiguration from './components/admin/HolidayConfiguration';
import ServiceTimesConfiguration from './components/admin/ServiceTimesConfiguration'; // ✅ NEUE IMPORT

function App() {
  return (
    <AuthProvider>
      <ServiceTimesProvider> {/* ✅ NEUER PROVIDER */}
        <MenuProvider>
          <Router>
            <div className="min-h-screen bg-gradient-to-br from-orange-50 to-amber-50">
              <Routes>
                {/* Public Routes */}
                <Route path="/" element={<MenuOverview />} />
                <Route path="/anmeldung/:day" element={<RegistrationForm />} />
                <Route path="/anmeldung/flexible/:day" element={<RegistrationForm />} />
                <Route path="/anmeldung/next-flexible/:day" element={<RegistrationForm />} />
                <Route path="/naechste-woche" element={<NextWeekMenu />} />

                {/* Admin Routes */}
                <Route path="/admin/login" element={<LoginForm />} />
                <Route path="/admin/*" element={<AdminLayout />}>
                  <Route index element={<Dashboard />} />
                  <Route path="aktuelle-menus" element={<CurrentMenus />} />
                  <Route path="naechste-menus" element={<NextWeekMenus />} />
                  <Route path="templates" element={<MenuTemplates />} />
                  <Route path="anmeldungen" element={<Registrations />} />
                  <Route path="newsletter" element={<EmailNewsletter />} />
                  <Route path="tage-konfiguration" element={<DayConfiguration />} />
                  <Route path="feiertage" element={<HolidayConfiguration />} />
                  <Route path="servicezeiten" element={<ServiceTimesConfiguration />} /> {/* ✅ NEUE ROUTE */}
                </Route>

                {/* Fallback Route */}
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </div>
          </Router>
        </MenuProvider>
      </ServiceTimesProvider>
    </AuthProvider>
  );
}

export default App;